import { useCreateExamMutation as useCreateExamination } from '../../../generated/graphql';

export default useCreateExamination;
